// $(document).ready(function () {
const $tabs = $('.tabs__items li');

function cardLoad() {

    fetch("?section_id=main-collection")
        .then((res) => res.text())
        .then((data) => {
            var cart__html = $(data);
            var render__html = $(".product-cards", cart__html);
            $(".product-cards").replaceWith(render__html);
            var render__html = $(".shop-hero__inner_collection", cart__html);
            $(".shop-hero__inner_collection").replaceWith(render__html);

            // headerSticky();
        });
}

function updateURLPath(handle) {
    const newPath = `/collections/${handle}`;
    window.history.pushState({}, '', newPath);
}

$tabs.on('click', function (e) {
    const handle = $(this).data('collection');

    if (!handle) {
        return;
    }

    e.preventDefault();

    // Update active class
    $tabs.removeClass('active');
    $(this).addClass('active');

    updateURLPath(handle);

    cardLoad(handle);
});

const currentPath = window.location.pathname;
const collectionHandle = currentPath.split('/collections/')[1];

if (collectionHandle) {
    const $matchedTab = $tabs.filter(`[data-collection="${collectionHandle}"]`);
    if ($matchedTab.length) {
        $tabs.removeClass('active');
        $matchedTab.addClass('active');
        // cardLoad(collectionHandle);
    }
}
// });




// function headerSticky() {

//     let lastScrollTop = 0;
//     const header = document.querySelector('header');
//     const hero = document.querySelector('.hero , .shop-hero , .product, .shop-hero__inner_collection');
//     if (!header || !hero) return;
//     window.addEventListener('scroll', function () {
//         const currentScroll = window.scrollY;
//         const heroHalf = hero.offsetHeight / 2;
        
//         if (currentScroll > 200) header.classList.add('header-sticky');
//         else header.classList.remove('header-sticky');

//         if (currentScroll === 0) header.style.transform = 'translateY(0)';
//         else if (currentScroll < heroHalf) header.style.transform = 'translateY(-100%)';
//         else if (currentScroll < lastScrollTop) header.style.transform = 'translateY(0)';
//         else header.style.transform = 'translateY(-100%)';
//         lastScrollTop = currentScroll;
//     });
// }
// headerSticky();




function cartOpen() {
    $("body").addClass('cart-drawer-open');

}


document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".product-cards__img, .best-seller__img");

  cards.forEach(card => {
    const video = card.querySelector(".product-cards__hover, .best-seller__hover-img");

    if (video) {
      // On hover → restart and play
      card.addEventListener("mouseenter", () => {
        video.currentTime = 0; // rewind
        video.play();
      });

      // On mouse leave → pause and reset
      card.addEventListener("mouseleave", () => {
        video.pause();
        video.currentTime = 0; // reset
      });
    }
  });
});
